import React, {Component} from 'react';
import $ from 'jquery';
import {AJAX, close_popup, show_popup, hidePreloader, showPreloader} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import valid from "card-validator";

class PaymentOnlyPage extends Component {
	constructor(props) {
		super(props);
		this.onProceed = this.onProceed.bind(this);
		this.onBlurHandler = this.onBlurHandler.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onPayment = this.onPayment.bind(this);
		this.onPaymentOnly = this.onPaymentOnly.bind(this);
		this.onCancelPayment = this.onCancelPayment.bind(this);
		this.onCheckPayment = this.onCheckPayment.bind(this);

		this.state = {
			pressProceed: false,
			card_numberError: 'This field is required.',
			card_numberDirty: false,
			expiry_monthError: 'This field is required.',
			expiry_monthDirty: false,
			expiry_yearError: 'This field is required.',
			expiry_yearDirty: false,
			security_codeError: 'This field is required.',
			security_codeDirty: false,
			customer_fnameError: 'This field is required.',
			customer_fnameDirty: false,
			customer_lnameError: 'This field is required.',
			customer_lnameDirty: false,
			validate: false,
			windcave_session_id: '',
			first_check: false,
			card_data: {},
			windcave_3dsecure_link: '',
			end_time: 0,
			duration: 0,
			merchantReference: '',
			link_active: this.props.payment_amount.success && !this.props.payment_amount.expired,
			error_message: this.props.payment_amount.error_messages ? this.props.payment_amount.error_messages:(this.props.payment_amount.expired?'This Link Has Already Expired':''),
		};
	}

	componentWillUnmount() {
		this.stop_3dSecure();
	}

	setEnd_3dSecure() {
		this.setState({end_time: (moment().valueOf() + 1860000)}); // a half of hour
		setTimeout(()=>this.start_3dSecure(), 1000);
	}

	start_3dSecure() {
		if (this.state.end_time > 0) {
			let startTime = moment().valueOf();
			let duration = this.state.end_time - startTime;
			this.setState({duration: duration});
			if (duration <= 0) {
				this.stop_3dSecure();
				return false;
			}
			setTimeout(() => this.start_3dSecure(), 1000);
		}
	}

	stop_3dSecure() {
		this.setState({end_time: 0, duration: 0});
	}

	onBlurHandler(e) {
		let name = e.target.name + 'Dirty';
		this.setState({[name]: true});
	}

	onChange(e) {
		let nameError = e.target.name + 'Error';
		if (e.target.value.length > 0) {
			this.setState({[nameError]: ''});
		}
		else {
			this.setState({[nameError]: 'This field is required.'});
		}
	}

	onProceed(e) {
		let fields = this.props.booking_field_list.payment; // validate need all fields
		let fields_send = this.props.booking_field_list.payment_send; // send need card holder name only
		let btn = e.target;
		let form_inputs = $(btn).closest('.card-data');
		let card_data = {}; // card info for send on windcave
		let params = {};
		let t = this;

		let validate = true;
		let toSet = {};

		Object.keys(fields_send).map((item) => {
			let el = form_inputs.find('[name='+fields_send[item]+']');
			if (el.length) {
				if (fields_send[item] == 'card_number') {
					params['payment[' + fields_send[item] + ']'] = el[0].value.trim().replace(/\s+/g, '').slice(-4);
				}
				else {
					params['payment[' + fields_send[item] + ']'] = el[0].value.trim();
				}
			}
		});

		Object.keys(fields).map((item) => {
			if (this.state[fields[item] + 'Error'] !== '') {
				toSet[fields[item] + 'Dirty'] = true;
				validate = false;
			}
			// save card data
			let el = form_inputs.find('[name='+fields[item]+']');
			if (el.length) {
				if (['card_number', 'security_code', 'expiry_month', 'expiry_year'].includes(fields[item]))
					card_data[fields[item]] = el[0].value.replace(/\s+/g, '');
				else
					card_data[fields[item]] = el[0].value.trim();
			}
		});

		const numberValidation = valid.number(card_data['card_number']);
		if (
			card_data['card_number'].length < 13 ||
			card_data['card_number'].length > 19 ||
			!numberValidation.isValid
		) {
			toSet['card_numberError'] = 'Incorrect card number';
			toSet['card_numberDirty'] = true;
			validate = false;
		}

		const cvvValidation = valid.cvv(card_data['security_code']);
		if (!cvvValidation.isValid) {
			toSet['security_codeError'] = 'Incorrect security code';
			toSet['security_codeDirty'] = true;
			validate = false;
		}

		const expiryValidation = valid.expirationDate({
			month: card_data['expiry_month'],
			year: card_data['expiry_year']
		});
		if (!expiryValidation.isValid) {
			toSet['expiry_monthError'] = 'Incorrect expiry month';
			toSet['expiry_monthDirty'] = true;
			validate = false;
		}


		toSet['card_data'] = card_data;
		toSet.validate = validate;
		this.setState(toSet);

		if (validate) {
			params.action = 'api/booking/create_session';
			params.amount = this.props.payment_amount.amount;
			params.auth_amount = this.props.payment_amount.auth_amount;
			params.total_amount = this.props.payment_amount.total_amount;
			params.reservationref = this.props.payment_amount.reservationref;
			params.id_payment_link = this.props.payment_amount.id_payment_link;
			params.transaction_type = this.props.payment_amount.transaction_type;

//			console.log('params', params, card_data);
			t.setState({pressProceed: true});

			AJAX(bm_ajax_url, 'POST', params, {
				response_json: true,
				func_waiting: function () {
					showPreloader();
				},
				func_callback: function (resp) {

					/*
            link_active: this.props.payment_amount.success && !this.props.payment_amount.expired,
			error_message: this.props.payment_amount.error_messages ? this.props.payment_amount.error_messages:(this.props.payment_amount.expired?'Link is expired':''),
		    */
					if (resp.link_issues) {
						t.setState({
							pressProceed: false,
							link_active: false,
							error_message: resp.link_issues.expired?'This Link Has Already Expired':resp.link_issues.error_messages
						});
						hidePreloader();
					}
					else {
						if (!resp.error && resp.ajax_link) {
							t.setState({windcave_session_id: resp.windcave_session_id, merchantReference: resp.merchantReference});
							let params_payment = {
								card: {
									cardHolderName: t.state.card_data['customer_fname'] + ' ' + t.state.card_data['customer_lname'],
									cardNumber: t.state.card_data['card_number'].replace(/\s+/g, ''),
									dateExpiryMonth: t.state.card_data['expiry_month'],
									dateExpiryYear: t.state.card_data['expiry_year'],
									cvc2: t.state.card_data['security_code'].replace(/\s+/g, '')
								}
							};
//						navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent('Ajax link: '+JSON.stringify(resp.ajax_link))+'&origin='+bf_debug_telegram_original);
//						navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent('Ajax send data: '+JSON.stringify(params_payment))+'&origin='+bf_debug_telegram_original);

							$.ajax({
								url: resp.ajax_link,
								headers: {'Content-Type':'application/json'},
								type: 'POST',
								data: JSON.stringify(params_payment),
								cache: false,
								dataType: 'json',
								success: function (response, status, jqXHR) {

//								navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent('Ajax link response: '+JSON.stringify(response))+'&origin='+bf_debug_telegram_original);

//								console.log(response, status);

									if (response['links'][0]['href'] !== undefined && response['links'][0]['href'] != "") {
										t.setState({windcave_3dsecure_link: response['links'][0]['href']});
										t.setEnd_3dSecure();

										hidePreloader();

										let content =
											<div className="row">
												<div className="col-12 text-center" style={{paddingRight: "0", paddingLeft: "0"}}>
													<div className="row m-3">
														<div className="col-12 text-center gray" style={{padding: "0"}}>
															<iframe id={'windcave_3dsecure_iframe'} style={{border: "none"}}
																	src={response['links'][0]['href']}></iframe>
														</div>
													</div>
												</div>
											</div>;
										show_popup(content, {auto_close: false});

										//if device width < 420px, we calculate indent for center alignment
										if (window.innerWidth < 420) {
											let windcave_3dsecure_iframe_width = ((420 - window.innerWidth) / 2) + 3;
											document.getElementById('windcave_3dsecure_iframe').style.marginLeft = '-' + windcave_3dsecure_iframe_width + 'px';
										}

										setTimeout(t.onCheckPayment, 10000, false); // check payment after 30 seconds
									}
									else {
// moved down temporarily			showPopupWithGoBack('<div>Sorry, unfortunately your payment could not be completed. <br/>Please wait 2 minutes and then try again. <br/>If it still fails, please call Go With The Gecko support on <a href="tel:1300826883">1300 826 883</a>.</div>');

										let windcave_session_id = '';
										if (resp.windcave_session_id !== undefined)
											windcave_session_id = resp.windcave_session_id;

										AJAX(
											bm_ajax_url,
											'POST',
											{action: 'api/booking/payment_windcave_failed', windcave_session_id: windcave_session_id, status: jqXHR.status, statusText: jqXHR.statusText, responseText: jqXHR.responseText, success: 'empty link'},
											{
												response_json: true,
												func_callback: function (response_failed) {
													//console.log(response_failed);
													if (response_failed.reCo !== undefined && response_failed.reCo == "AQ")
														showPopupWithGoBack('<div>Sorry, but we are temporarily unable to accept AMEX cards online. <br/>Please call <a href="tel:1300826883">1300 826 883</a> to handle this purchase.</div>');
													else
														showPopupWithGoBack('<div>Sorry, unfortunately your payment could not be completed. <br/>Please wait 2 minutes and then try again. <br/>If it still fails, please call Go With The Gecko support on <a href="tel:1300826883">1300 826 883</a>.</div>');
												}
											});
										t.setState({pressProceed: false});

										if (bf_debug_telegram_original != 'test')
											navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent('Response 3DSecure link: '+JSON.stringify(response))+'&origin='+bf_debug_telegram_original);
									}

									hidePreloader();
								},
								error: function (jqXHR, status, errorThrown) {


									if (typeof Bugsnag !== 'undefined' && Bugsnag.notify) {
										var error = new Error('error: ' + status);
										Bugsnag.notify(error);
									}

									//console.log(jqXHR, status, errorThrown);
									showPopupWithGoBack('<div>There was an error taking payment with this card. <br/>Please double check the entered details and try again. <br/>If you still have problems, call the office at <a href="tel:1300826883">1300 826 883</a>.</div>');

									let windcave_session_id = '';
									if (resp.windcave_session_id !== undefined)
										windcave_session_id = resp.windcave_session_id;

									AJAX(
										bm_ajax_url,
										'POST',
										{action: 'api/booking/payment_windcave_failed', windcave_session_id: windcave_session_id, status: jqXHR.status, statusText: jqXHR.statusText, responseText: jqXHR.responseText},
										{
											response_json: true,
											func_callback: function (response_failed) {
												//console.log(response_failed);
											}
										});

									if (bf_debug_telegram_original != 'test') {
										let responseText = jqXHR.responseText;
										if (responseText != undefined)
											responseText = responseText.substring(0, 500);
										navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message=' + encodeURIComponent('Error response 3DSecure link, Status: ' + jqXHR.status + ' Status Text: ' + jqXHR.statusText + ' Response Text: ' + responseText) + '&origin=' + bf_debug_telegram_original);
									}

									t.setState({pressProceed: false});
									hidePreloader();
								}
							})
						}
						else {
							t.setState({pressProceed: false});
							if (resp.error === true) {
								showPopupWithGoBack('<div class="text-center">Sorry, unfortunately your payment could not be processed due to connection issues with the payment system.<br/> Please wait 2 minutes and then try again. If it still fails, please call Go With The Gecko support on <a href="tel:1300826883">1300 826 883</a>.</div>');
							} else {
								showPopupWithGoBack(resp.error);
							}

							hidePreloader();
						}
					}

					t.props.handleSetSomeBlock('scroll_to_element', '');
				},
				func_error: function (resp) {
					hidePreloader();
					showPopupWithGoBack(resp.message);
				}
			});
		}
	}

	onCancelPayment() {
		close_popup();
		this.props.handleSetSomeBlock('payment_show', true);
	}

	onPaymentOnly() {
		close_popup();

		this.props.handleSetSomeBlock('payment_show', false);
		this.props.handleSetSomeBlock('success_show', true);
	}

	onPayment(first_check) {
		close_popup();

		let t = this;
		let params = {
			action: 'api/booking/payment_only_windcave',
			merchantReference: this.state.merchantReference
		};

		this.setState({first_check: first_check});

		AJAX(bm_ajax_url, 'POST', params, {
			response_json: true,
			func_waiting: function () {
				showPreloader();
			},
			func_callback: function (resp) {
				//console.log(resp);

				if (!resp.error) {
					hidePreloader();

					t.props.handleSetSomeBlock('payment_show', false);
					t.props.handleSetSomeBlock('success_show', true);
				}
				else {
					if (t.state.first_check) {
						setTimeout(t.onPayment, 60000, false);  // if auth not ready, then repeat one time after one minute
						t.setState({first_check: false});
					}
					else {
						hidePreloader();
						t.setState({pressProceed: false});

						if (resp.error === 1) {
							showPopupWithGoBack('<div class="text-center">There was a problem completing all parts of your payment.<br/>Please ensure you have enough funds for the payment including authorisation, and if you still have problems please call Go With The Gecko support on <a href="tel:1300826883">1300 826 883</a>.</div>');
						}
					}
				}
			},
			func_error: function (resp) {
				hidePreloader();
				showPopupWithGoBack(resp.message);
			}
		});
	}

	onCheckPayment() {
		if (this.state.duration <= 0) {
			showPopupWithGoBack('<div class="text-center">Sorry, unfortunately a 3D code has not been entered in time for this payment.<br/>You can try again, but only when ready to input the required 3D code.<br/>If you still have issues, please call Go With The Gecko support on <a href="tel:1300826883">1300 826 883</a>.</div>');
			return;
		}

		let t = this;
		let params = {
			action: 'api/booking/payment_check',
			windcave_session_id: this.state.windcave_session_id
		};

		AJAX(bm_ajax_url, 'POST', params, {
			response_json: true,
			func_callback: function (resp) {
//				console.log(resp);

				if (!resp.error) {
					let content =
						<div className="row">
							<div className="col-12 text-center" style={{paddingRight: "0", paddingLeft: "0"}}>
								<div className="row m-3">
									<div className="col-12 text-center gray" style={{padding: "0"}}>
										<iframe id={'windcave_3dsecure_iframe'} style={{border: "none"}}
												src={t.state.windcave_3dsecure_link}></iframe>
									</div>
								</div>
								<div className={'row mb-3'}>
									<div className="col-12 text-center">
										<button type="button" className={'btn btn-success'}
												onClick={() => {
													(t.props.payment_amount.transaction_type === 'purchase_auth') ? t.onPayment(true) : t.onPaymentOnly()
												}}>Payment was successful
										</button>
									</div>
								</div>
							</div>
						</div>;
					show_popup(content, {auto_close: false});
					t.stop_3dSecure();
				}
				else {
					if (resp.timeout || resp.transaction_error) {
						let content =
							<div className="row">
								<div className="col-12 text-center" style={{paddingRight: "0", paddingLeft: "0"}}>
									<div className="row m-3">
										<div className="col-12 text-center gray" style={{padding: "0"}}>
											<iframe id={'windcave_3dsecure_iframe'} style={{border: "none"}}
													src={t.state.windcave_3dsecure_link}></iframe>
										</div>
									</div>
									<div className={'row mb-3'}>
										<div className="col-12 text-center">
											<button type="button" className={'btn btn-secondary'}
													onClick={t.onCancelPayment}>Close
											</button>
										</div>
									</div>
								</div>
							</div>;
						show_popup(content, {auto_close: false});
						t.stop_3dSecure();
						t.setState({pressProceed: false});
					}
					else {
						setTimeout(t.onCheckPayment, 2000, false);  // repeat one time after 2 seconds
					}
				}
			},
			func_error: function (resp) {
//				console.log(resp);
				setTimeout(t.onCheckPayment, 2000, false);
			}
		});
	}

	render() {
		let current_year = Number(moment().format('YY'));
		let years_list = [];

		for (let i = current_year; i <= (current_year + 20); i++) {
			years_list.push(i);
		}

		let cvn_text = "Card Verification Number (CVN)\n" +
			"A three-digit security number that usually appears on the back of your credit or debit card. Sometimes called a card security code or card verification value, it provides extra protection against fraud.\n" +
			"When asked for your CVN, be sure to enter it properly or your payment might not be successful.\n" +
			"CVNs can appear in different spots on each card. Often, you can find your CVN on the back of your card, near or next to the area where you can add your signature. Some cards show it on the front, near your account number. <br/><br/><img src='../../wp-content/plugins/booking-form/images/security-code.jpg' alt='CVN Examples' className='aligncenter'/>";

		if ( !this.state.link_active )
			return (<>
				<RedirectOnlyHome />
				<div id={'id_payment_div'} className={'col card-data'} style={{padding: "20px 30px", marginBottom: "25px"}}>
					<h2 style={{padding: "40px 30px"}}>Error</h2>
					<div className="row justify-content-center justify-content-md-center">
						<div className="col-auto col-md-auto">
							<p style={{textAlign:"center",textTransform:"uppercase"}}>{this.state.error_message}</p>
							<p style={{textAlign:"center",marginTop:"20px"}}>
								<a href="tel:1300826883" className="btn btn-danger">
										<svg  className="icon-phone-svg" style={{fill:'currentColor', marginRight:"10px"}} viewBox="0 0 16 16">
											<path d="M11 10c-1 1-1 2-2 2s-2-1-3-2-2-2-2-3 1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8s6 4 8 4c0 0 3-2 3-3s-3-4-4-3z"></path>
										</svg>
									Call 1300 826 883</a>
							</p>
						</div>
					</div>
				</div>
			</>);
		else
			return (<>
				<RedirectOnlyHome />
				<div id={'id_payment_div'} className={'col card-data'} style={{padding: "20px 30px", marginBottom: "25px"}}>
					<h2>Credit Card Information</h2>
					{
						(this.props.payment_amount.amount) &&
						<h4>Hire Charge: ${this.props.payment_amount.amount}</h4>
					}
					{
						(this.props.payment_amount.auth_amount) &&
						<h4>Pre-Authorization Amount: ${this.props.payment_amount.auth_amount}</h4>
					}
					{
					  (this.props.payment_amount.total_amount) &&
					  <h4>Total Price: ${this.props.payment_amount.total_amount}</h4>
					}
					<div className="row">
						<div className={'form-group col-md-2 fake-placeholder '+((this.state.card_numberDirty && this.state.card_numberError) && 'has-danger')}>
							<div className="placeholder" style={{display: "none"}}>
								<label>Card number</label>
								<span className="star">*</span>
							</div>
							<input className="form-control required"
								   type="text"
								   name="card_number"
								   placeholder={"Card number *"}
								   onChange={this.onChange}
								   onBlur={this.onBlurHandler}
							/>
							{
								(this.state.card_numberDirty && this.state.card_numberError) &&
								<small className="form-control-feedback d-block">{this.state.card_numberError}</small>
							}
						</div>
						<div className={'form-group col-md-2 '+((this.state.expiry_monthDirty && this.state.expiry_monthError) && 'has-danger')}>
							<select className="form-control"
									name="expiry_month"
									id="select_expiry_month"
									onChange={this.onChange}
									onBlur={this.onBlurHandler}>
								<option value="">Expiry month *</option>
								<option value="01">01</option>
								<option value="02">02</option>
								<option value="03">03</option>
								<option value="04">04</option>
								<option value="05">05</option>
								<option value="06">06</option>
								<option value="07">07</option>
								<option value="08">08</option>
								<option value="09">09</option>
								<option value="10">10</option>
								<option value="11">11</option>
								<option value="12">12</option>
							</select>
							{
								(this.state.expiry_monthDirty && this.state.expiry_monthError) &&
								<small className="form-control-feedback d-block">{this.state.expiry_monthError}</small>
							}
							<div id="holder_select_expiry_month" className="select-holder" style={{display: "none"}}>Expiry month <span style={{color:"red"}}>*</span></div>
						</div>
						<div className={'form-group col-md-2 '+((this.state.expiry_yearDirty && this.state.expiry_yearError) && 'has-danger')}>
							<select className="form-control required"
									name="expiry_year"
									id="select_expiry_year"
									onChange={this.onChange}
									onBlur={this.onBlurHandler}>
								<option value="">Expiry year *</option>
								{
									years_list.map((val) => <option key={val} value={val}>{val}</option>)
								}
							</select>
							{
								(this.state.expiry_yearDirty && this.state.expiry_yearError) &&
								<small className="form-control-feedback d-block">{this.state.expiry_yearError}</small>
							}
							<div id="holder_select_expiry_year" className="select-holder" style={{display: "none"}}>Expiry year <span style={{color:"red"}}>*</span></div>
						</div>
						<div className={'form-group col-md-2 fake-placeholder '+((this.state.security_codeDirty && this.state.security_codeError) && 'has-danger')}>
							<div className="placeholder" style={{display: "none"}}>
								<label>Security Code</label>
								<span className="star">*</span>
							</div>
							<input className="form-control required"
								   type="text"
								   name="security_code"
								   placeholder={"Security Code *"}
								   onChange={this.onChange}
								   onBlur={this.onBlurHandler}
								   style={{width: "calc( 100% - 24px)", display: "inline-block"}}
							/>
							<i className="tooltip-info" data-tip data-for="react_tooltip_cvn" style={{marginLeft: "4px", top: "-6px"}}>&nbsp;</i>
							<ReactTooltip
								id="react_tooltip_cvn"
								place="left"
								effect="solid"
								multiline={true}
								className={'react_tooltip'}
								backgroundColor={'black'}
								html={true}
								scrollHide={true}
								isCapture={true}>
								{cvn_text}
							</ReactTooltip>
							{
								(this.state.security_codeDirty && this.state.security_codeError) &&
								<small className="form-control-feedback d-block">{this.state.security_codeError}</small>
							}
						</div>
						<div className={'form-group col-md-2 fake-placeholder '+((this.state.customer_fnameDirty && this.state.customer_fnameError) && 'has-danger')}>
							<div className="placeholder" style={{display: "none"}}>
								<label>Customer first name</label>
								<span className="star">*</span>
							</div>
							<input className="form-control required"
								   type="text"
								   name="customer_fname"
								   placeholder={"Customer first name *"}
								   onChange={this.onChange}
								   onBlur={this.onBlurHandler}
							/>
							{
								(this.state.customer_fnameDirty && this.state.customer_fnameError) &&
								<small className="form-control-feedback d-block">{this.state.customer_fnameError}</small>
							}
						</div>
						<div className={'form-group col-md-2 fake-placeholder '+((this.state.customer_lnameDirty && this.state.customer_lnameError) && 'has-danger')}>
							<div className="placeholder" style={{display: "none"}}>
								<label>Customer last name</label>
								<span className="star">*</span>
							</div>
							<input className="form-control required"
								   type="text"
								   name="customer_lname"
								   placeholder={"Customer last name *"}
								   onChange={this.onChange}
								   onBlur={this.onBlurHandler}
							/>
							{
								(this.state.customer_lnameDirty && this.state.customer_lnameError) &&
								<small className="form-control-feedback d-block">{this.state.customer_lnameError}</small>
							}
						</div>
					</div>
					<div className="row justify-content-center justify-content-md-center">
						<div className="col-auto col-md-auto">
							<input type="button" className="btn btn-success" value="Proceed" onClick={this.onProceed} disabled={this.state.pressProceed}/>
						</div>
					</div>
				</div>
			</>);
	}
}

export default PaymentOnlyPage;
